import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { reject } from 'lodash/fp';
import { requestInitalData } from 'actions/assign';
import { ORDER, COLUMNS, TYPES } from 'constants/config';
import { hasFeatureFlags } from 'utils/features';
import AssignableCollection from '../shared/AssignableCollection';
import Search from '../shared/Search';
import Filter from '../shared/Filter';
import Sort from '../shared/Sort';

class ContentView extends PureComponent {
  componentDidMount() {
    this.props.requestInitalData();
  }

  static sortOptions = [
    {
      order: ORDER.DESC,
      type: COLUMNS.LAST_MODIFIED,
      label: 'Recently Updated',
    },
    { order: ORDER.ASC, type: COLUMNS.TITLE, label: 'Name A-Z' },
    { order: ORDER.DESC, type: COLUMNS.TITLE, label: 'Name Z-A' },
  ];

  static filterOptions = [
    { value: 'Lesson', label: 'Lessons' },
    { value: 'Resource', label: 'Resources' },
    { value: TYPES.PATH, label: 'Paths' },
  ];

  get filterOptions() {
    let { filterOptions } = ContentView;
    if (!this.props.hasResourceExperiment) {
      filterOptions = reject({ value: 'Resource' })(filterOptions);
    }
    if (this.props.hasCertificationsFeature) {
      filterOptions = reject({ value: TYPES.PATH })(filterOptions);
      filterOptions.push({
        value: TYPES.PATH,
        label: 'Paths & Certification Paths',
      });
    }
    return filterOptions;
  }

  render() {
    return (
      <div className="AssignModal-detailsView">
        <Search
          placeholder="Search content"
          getFiltersRef={() => this.filters}
        />
        <div
          ref={n => {
            this.filters = n;
          }}
          className="AssignModal-filters"
        >
          <Filter options={this.filterOptions} />
          <Sort options={this.constructor.sortOptions} />
        </div>
        <AssignableCollection />
      </div>
    );
  }
}

const mapStateToProps = state => ({
  hasResourceExperiment: state.meta.features.resource_experiment,
  hasCertificationsFeature: hasFeatureFlags(['certifications']),
});

const mapDispatchToProps = dispatch => ({
  requestInitalData() {
    dispatch(requestInitalData());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(ContentView);
